var template = require('../../templates/payslips/Layout.ejs');
var PayslipsView = require('./Payslips');
var ViewView = require('./View');

module.exports = Backbone.View.extend({

    initialize: function(options) {
        var self = this;
        _.extend(self, options);
        self.render();
    },

    render: function() {
        var self = this;
        self.$el.html(template());

        return self;
    },

    renderPayslips: function(options) {
        var self = this;
        self.payslip = new PayslipsView(
            _.extend({$el: self.$('.js-tab-content')}, options)
        );
        self.$('.sk-spinner').hide();

        return self;
    },

    renderView: function(options) {
        var self = this;
        self.payslip = new ViewView(
            _.extend({el: self.$('.js-tab-content')}, options)
        );
        self.$('.sk-spinner').hide();

        return self;
    }
});



// WEBPACK FOOTER //
// ./app/employee/views/payslips/Layout.js